module.exports = __webpack_public_path__ + "img/s.05f087c2.jpg";